<template>
  <div id="hress3e" class="page-hress3e">
    <hrms15e />
  </div>

</template>

<script>
import hrms15e from 'components/hrms15e/component'

export default {
  name: 'hress3e',
  components: {
    hrms15e
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?0926d839